export default "__VITE_ASSET__DtoFkUoC__"